import React from 'react';
import { useLanguage } from '../../App';

export default function LanguageToggle({ className = '' }) {
  const { language, setLanguage } = useLanguage();

  return (
    <div
      className={`language-toggle ${className}`}
      data-testid="language-toggle"
    >
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
        data-testid="lang-en-button"
      >
        EN
      </button>
      <button
        className={`lang-btn ${language === 'bm' ? 'active' : ''}`}
        onClick={() => setLanguage('bm')}
        data-testid="lang-bm-button"
      >
        BM
      </button>
    </div>
  );
}
